export default __webpack_public_path__ + "static/media/taan.f9f71c88.svg";